import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=1caf2f79&scoped=true&"
import script from "./FormCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=1caf2f79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf2f79",
  null
  
)

export default component.exports